import api from './apiLibrary';

const API = {
    getTableData(params) {
        return api.get('/api/data/team-ranking', params);
    },
};

export default API;
